import { PriceBreakdown } from './Order'
import { Proteins } from './Pet'

export const hasWeightLimit = (product: ProductVariant) => product.needsMinimumWeightToPurchase

export enum ProductTypes {
  PATTIES = 'PATTIES',
  BONES = 'BONES',
  TREATS = 'TREATS',
  MEAL_PLANS = 'MEAL_PLANS',
  GIFT = 'GIFT',
  FREEZE_DRIED = 'FREEZE_DRIED'
}

export enum RawFeedingProductType {
  FROZEN = 'FROZEN',
  FREEZE_DRIED = 'FREEZE_DRIED',
}

export enum PouchSize {
  SIX_OUNCES = 6,
  SIXTEEN_OUNCES = 16,
  TWENTY_FIVE_OUNCES = 25,
}

export type TranslatedDescriptions = {
  enUS: string
  esES: string
}

/**
 * Mirrors api-core's `ProductVariantListElementDTO`, served by the
 * `/product-variants/preview` list and related-variants endpoints.
 * `description` is a plain string because that DTO flattens it to
 * `description.enUS`. The show endpoint returns `ProductVariantDetail` below.
 */
export type ProductVariant = {
  productVariantId: string
  productId: string
  name: string
  slug: string
  description: string
  needsMinimumWeightToPurchase: boolean
  unitWeight?: number
  price: PriceBreakdown
  proteins: Proteins[]
  weight: number
  type: ProductTypes
  image: string
}

export type ProductVariantSnapshot = {
  productVariantId: string
  productId: string
  addOnExpiresAt?: string
  isAddOn: boolean
  name: string
  price: number
  quantity: number
  weight: number
  slug: string
  type: ProductTypes
}

type AnalysisPercentages = {
  minRawProtein: number
  minRawFat: number
  maxRawFiber: number
  maxMoisture: number
}

/**
 * Mirrors api-core's `ProductVariantShowResponseDTO`, served by
 * `/product-variants/:slug/preview`. Unlike the list DTO, `description` is
 * localized here, hence the `Omit`.
 */
export type ProductVariantDetail = Omit<ProductVariant, 'description'> & {
  description: TranslatedDescriptions
  recurringPrice?: PriceBreakdown
  details: TranslatedDescriptions[]
  ingredients: { [k in Proteins]?: TranslatedDescriptions[] }
  analysisPercentages: { [k in Proteins]?: AnalysisPercentages }
  kilocaloriesPerOunces: { [k in Proteins]?: number }
  guidelines: TranslatedDescriptions[]
}

export type ShoppingCartItem = ProductVariant & {
  quantity: number
}

export type ShoppingCart = {
  clientId: string
  items: ShoppingCartItem[]
  priceBreakdown: PriceBreakdown
}
